'use strict';

angular.module('libraryModule')

.config(function (modalStateProvider)
{
    modalStateProvider.state('admin.media.basket', {
        url: '/basket/{id:[0-9\w-]+}',
        templateUrl: 'library/library.modals/library.basket.modal.html',
        controller: 'LibraryBasketModalController',
        resolve: {
            model: ['Asset', 'modalState', function (Asset, modalState)
            {
                return Asset.find(modalState.stateParams.id);
            }],
            files: ['File', 'modalState', function (File, modalState)
            {
                const params = {asset_id: modalState.stateParams.id};
                File.ejectAll(params);

                return File.findAll(params);
            }]
        }
    });
});
